module.exports = __webpack_public_path__ + "static/img/preview.dea7e803.png";